import * as React from 'react'

import '../styles/StarRating.scss'

import StarRating from 'react-star-ratings'

import { theme } from '../constants/components/starRating-consts'

export interface StarRatingsProps {
    initialRating: number
    readonly?: boolean
    className?: string
    onClick?(value: number): void
    onHover?(value: number): void
}

export interface StarRatingsState {
    initialRating: number
}

export class StarRatings extends React.Component<StarRatingsProps, StarRatingsState> {

    public static defaultProps: Partial<StarRatingsProps> = {
        readonly: false
    }

    constructor(props: any) {
        super(props)
        this.state = {
            initialRating: this.props.initialRating
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.initialRating !== nextProps.initialRating) {
            this.setState({
                initialRating: nextProps.initialRating
            })
        }
    }

    onHover = (nextValue: number) => {
        if (this.props.onHover) {
            this.props.onHover(nextValue)
        }
    }

    onClick = (value: number) => {
        if (this.props.onClick) {
            this.props.onClick(value)
        }
    }

    render() {
        return (
            <div className="star-rating">
                {
                    this.props.readonly ?
                        <StarRating
                            rating={this.state.initialRating}
                            color={theme.colors.accentYellow}
                            starRatedColor={theme.colors.accentYellow}
                            starDimension={theme.starSize}
                            starSpacing={theme.starSpacing}
                            numberOfStars={5}
                            svgIconPath={theme.path}
                        />
                        :
                        <StarRating
                            rating={this.state.initialRating}
                            changeRating={this.onClick}
                            color={theme.colors.accentYellow}
                            starRatedColor={theme.colors.accentYellow}
                            starHoverColor={theme.colors.accentYellow}
                            starDimension={theme.starSize}
                            starSpacing={theme.starSpacing}
                            numberOfStars={5}
                            svgIconPath={theme.path}
                        />
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/StarRating.tsx